import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Dialog, DialogProps, DialogTitle, MenuItem, Select, Typography } from '@material-ui/core';
import { RootState } from 'interfaces';
import { Confluence } from '../interfaces';
import { TEMPLATE_TYPES } from '../helpers';
import { DefaultTemplate, LessonTemplate, PollTemplate } from './templates';

const TEMPLATES = new Map([
  [Confluence.ETemplateTypes.DEFAULT, DefaultTemplate],
  [Confluence.ETemplateTypes.LESSON, LessonTemplate],
  [Confluence.ETemplateTypes.POLL, PollTemplate],
]);

interface IProps extends Omit<DialogProps, 'onClose'> {
  article?: Confluence.IDefaultArticle | Confluence.ILessonArticle | null;
  parentId?: number | null;
  onClose(): void;
  onCreateOrUpdate?(article: Confluence.IDefaultArticle | Confluence.ILessonArticle): void;
}

const ArticleDialog = ({ article = null, parentId = null, onCreateOrUpdate, onClose, ...props }: IProps) => {
  const operations = useSelector((state: RootState) => state.operations);

  const [currentTemplate, setCurrentTemplate] = useState(Confluence.ETemplateTypes.DEFAULT);

  const Template = TEMPLATES.get(currentTemplate) || DefaultTemplate;

  useEffect(() => setCurrentTemplate(article?.templateType || Confluence.ETemplateTypes.DEFAULT), [article]);

  return (
    <Dialog
      {...props}
      disableEnforceFocus
      maxWidth="lg"
      fullWidth
      scroll="paper"
      PaperProps={{ style: { overflow: 'visible' } }}
    >
      <DialogTitle disableTypography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" component="h2">
            <b>{article ? 'Обновить' : 'Добавить'} статью</b>
          </Typography>

          {!article && (
            <Select
              value={currentTemplate}
              onChange={(event) => setCurrentTemplate(event.target.value as Confluence.ETemplateTypes)}
            >
              {Array.from(TEMPLATE_TYPES).map(([value, [label, operation]]) => (
                <MenuItem value={value} key={value} disabled={!operations.includes(operation)}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          )}
        </Box>
      </DialogTitle>

      <Template article={article} parentId={parentId} onCreateOrUpdate={onCreateOrUpdate} onClose={onClose} />
    </Dialog>
  );
};

export default ArticleDialog;
